<div *ngIf="lightLayout" cdkDrag>
    <div class="se-suggestion-selector-overlay-toolbar" cdkDragHandle>
        <mat-icon matTooltip="{{ 'se-ui-text-editor_cmd_close_tooltip' | translate }}"
                  class="se-suggestion-selector-close-button" (click)="onSelectorCloseCommand()">close</mat-icon>
    </div>
    <div class="se-suggestion-selector-overlay">
        <se-suggestion-selector [currentFilter]="currentFilter"
                                [suggestions]="filteredSuggestions"
                                (selectedSuggestion)="onSelectorSuggestionSelected($event)"
                                (preSelectedSuggestionEmitter)="onPreselectedSuggestion($event)"
                                (closeCommand)="onSelectorCloseCommand()">
        </se-suggestion-selector>
    </div>
</div>
<div cdkDrag *ngIf="!lightLayout">
    <div cdkDragHandle>
        <div class="se-suggestion-selector-overlay-toolbar"
             [ngClass]="{'se-suggestion-selector-overlay-toolbar_edit' : _editingView }">

            <button *ngIf="!_editingView"
                    mat-button matTooltip="{{'DefaultText_AddDefautText' | translate}}"
                    matTooltipPosition="right"
                    (click)="_onClickAddNew();">
                <mat-icon aria-hidden="false">post_add</mat-icon>
            </button>

            <button mat-button
                    matTooltip="{{ 'se-ui-text-editor_cmd_close_tooltip' | translate }}"
                    matTooltipPosition="left"
                    (click)="onSelectorCloseCommand()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </button>
        </div>
    </div>

    <div class="se-suggestion-selector-overlay__expander">
        <se-ui-default-text [_addingNewText]="_addNewSuggestion"
                            [currentFilter]="currentFilter"
                            [suggestions]="filteredSuggestions"
                            [defaultTextName]="defaultTextName"
                            (selectedSuggestion)="onSelectorSuggestionSelected($event)"
                            (preSelectedSuggestionEmitter)="onPreselectedSuggestion($event)"
                            (closeCommand)="onSelectorCloseCommand()"
                            (undoCommand)="onSelectorUndoCommand()"
                            (isEditing)="onEditing($event)">
        </se-ui-default-text>
    </div>
</div>

